import { useRulerModalContext, MAP_TOOLS } from "../../context/RulerContext";
import { Card, CardDescription, CardTitle } from "../ui/shadcn/card";

const INSTRUCTION_TEXTS = {
  [MAP_TOOLS.LOCATION]: {
    title: "Localizar",
    text: "Clique em um ponto no mapa para capturar a coordenada ou endereço.",
  },
  [MAP_TOOLS.MEASURE]: {
    title: "Medir distância",
    text: "Clique em pontos no mapa para traçar a distância. Dê um duplo clique para finalizar.",
  },
  [MAP_TOOLS.MEASURE_AREA]: {
    title: "Definir área",
    text: "Clique em pontos no mapa para cercar a área. Dê um duplo clique para fechar o polígono.",
  },
  [MAP_TOOLS.DRAW]: {
    title: "Desenhar",
    text: "Clique para desenhar livremente sobre o mapa.",
  },
};
interface InstructionCardViewProps {
  title: string;
  text: string;
}

const InstructionCardView = ({ title, text }: InstructionCardViewProps) => (
  <Card>
    <CardTitle>{title}</CardTitle>
    <CardDescription>{text}</CardDescription>
  </Card>
);

export const InstructionCard = () => {
  const { activeFunction, isFinished } = useRulerModalContext();

  if (!activeFunction || isFinished) {
    return null;
  }

  const content =
    INSTRUCTION_TEXTS[activeFunction as keyof typeof INSTRUCTION_TEXTS];

  if (!content) return null;

  return <InstructionCardView title={content.title} text={content.text} />;
};
